import {h, Fragment} from "preact"
import { useEffect } from "preact/hooks"
import { addToCart } from "../helpers"

export default function QuickAdd({ open, setOpen, productId, setSizeGuideOpen, sortedSkus, isPreorder, toggleRef }) {
    
    useEffect(() => { // close on Escape key
        const handleEscape = (e) => {
            if (e.key === 'Escape' && open) handleClose();
        };

        if (open) {
            document.addEventListener('keydown', handleEscape);
        }
        return () => document.removeEventListener('keydown', handleEscape);
    }, [ open ]);

    useEffect(() => { // close on outside click
        const handleClick = (e) => {
            const qaToggle = e.target.closest('.ns-quickadd-toggle');
            if(qaToggle) setOpen(false);
        }

        if(open) {
            document.addEventListener('click', handleClick);
        }
        return () => document.removeEventListener('click', handleClick);
    }, [ open ])

    const handleClose = () => {
        if (toggleRef?.current) {
            toggleRef.current.focus();
        }
        setOpen(false);
    };

    const handleAddToCart = async (e, id) => {
        e.preventDefault();
        await addToCart(id, isPreorder);
        handleClose();
    }

    return (sortedSkus?.length > 0 && (
        <>
            <div
                id={`ns-quickadd-${productId}`}
                class="ns-product-quickadd ns-fixed ns-lg-absolute ns-flex ns-flex-col"
                aria-modal="false"
                role="group"
                aria-label="Select product size to add to cart"
                aria-hidden={!open}
            >

                <div class="ns-quickadd-header ns-flex ns-flex-nowrap ns-items-center ns-justify-between">
                    <button 
                        type="button"
                        class="ns-sizeguide-toggle ns-lg-hidden"
                        aria-label="Open size guide"
                        onClick={() => setSizeGuideOpen(true)}
                    >
                        Size Guide
                    </button>
                    <button
                        type="button"
                        class="ns-quickadd-close ns-relative ns-flex ns-lg-hidden"
                        aria-label="Close quick add"
                        aria-expanded={open}
                        onClick={handleClose}
                    >
                        <span class="sr-only visually-hidden">Close Quick Add</span>
                        <span 
                            class="ns-close-icon ns-block ns-absolute"
                            role="presentation"
                            aria-hidden="true"
                        />
                    </button>

                    <h5 class="ns-quickadd-heading">Quick Add</h5>
                </div>

                <div class="ns-quickadd-sizes ns-w-100 ns-custom-scrollbar">
                    <p class="sr-only visually-hidden">Select Size:</p>
                    <ol class="ns-w-100 ns-flex ns-flex-col ns-items-center ns-justify-center ns-lg-flex-row ns-lg-justify-start">
                        {sortedSkus.map(sku => {
                            const size = sku.customFields.find(f => f.key === 'size')?.value;
                            return (
                                <li
                                    key={sku.id}
                                    type="button"
                                    class="ns-quickadd-size ns-block ns-w-100"
                                    aria-label={`Add size ${size} to cart`}
                                    disabled={sku.availability !== 'InStock'}
                                    >
                                    <input
                                        class="sr-only visually-hidden"
                                        type="radio"
                                        name={`quickadd-${productId}-size`}
                                        id={`quickadd-${productId}-size-${sku.id}`}
                                        value={sku.id}
                                        disabled={sku.availability !== 'InStock'}
                                        onChange={(e) => handleAddToCart(e, sku.id)}
                                    />
                                    <label 
                                        class="ns-quickadd-size-label ns-w-100 text-center"
                                        htmlFor={`quickadd-${productId}-size-${sku.id}`}
                                        tabIndex={0}
                                    >
                                        {size}
                                    </label>
                                </li>
                            )
                        })}
                    </ol>
                </div>
            </div>
        </>
    ))
}
